export var AI_REVIEW_FONT_VAR = '--ai-review-font';
export var AI_REVIEW_FONT_SIZE = 'clamp(12px, 0.625vw, 20px)';
export var scaled = function (factor) { return "calc(var(".concat(AI_REVIEW_FONT_VAR, ", 12px) * ").concat(factor, ")"); };
export var designPx = function (px) { return scaled(px / 12); };
export var REVIEW_GRID_COLUMNS = "repeat(auto-fill, minmax(min(100%, ".concat(designPx(340), "), 1fr))");
